import React from "react"
import game from "wolf-and-sheep.png"

const WolfAndSheep = props => <img src={game} className="game" {...props} />

export default WolfAndSheep